export const GET_SERVICE_MESSAGE_FROM_PUSH = 'GET_SERVICE_MESSAGE_FROM_PUSH'

export const GET_SALES_MESSAGE_FROM_PUSH = 'GET_SALES_MESSAGE_FROM_PUSH'

export const SEND_SERVICE_MESSAGE_STARTED = 'SEND_SERVICE_MESSAGE_STARTED'

export const SEND_SERVICE_MESSAGE_FAILED = 'SEND_SERVICE_MESSAGE_FAILED'

export const SEND_SERVICE_MESSAGE_SUCCESS = 'SEND_SERVICE_MESSAGE_SUCCESS'

export const SEND_SALES_MESSAGE_STARTED = 'SEND_SALES_MESSAGE_STARTED'

export const SEND_SALES_MESSAGE_FAILED = 'SEND_SALES_MESSAGE_FAILED'

export const SEND_SALES_MESSAGE_SUCCESS = 'SEND_SALES_MESSAGE_SUCCESS'

export const SET_CURRENT_SERVICE_THREAD = 'SET_CURRENT_SERVICE_THREAD'

export const SET_CURRENT_SALES_THREAD = 'SET_CURRENT_SALES_THREAD'

export const SET_CURRENT_DIRECT_THREAD = 'SET_CURRENT_DIRECT_THREAD'

export const GET_SERVICE_THREAD_STARTED = 'GET_SERVICE_THREAD_STARTED'

export const GET_SERVICE_THREAD_SUCCESS = 'GET_SERVICE_THREAD_SUCCESS'

export const GET_SERVICE_THREAD_FAILED = 'GET_SERVICE_THREAD_FAILED'

export const GET_SALES_THREAD_STARTED = 'GET_SALES_THREAD_STARTED'

export const GET_SALES_THREAD_SUCCESS = 'GET_SALES_THREAD_SUCCESS'

export const GET_SALES_THREAD_FAILED = 'GET_SALES_THREAD_FAILED'

export const RESOLVE_THREAD_STARTED = 'RESOLVE_THREAD_STARTED'

export const RESOLVE_THREAD_FAILED = 'RESOLVE_THREAD_FAILED'

export const RESOLVE_THREAD_SALES_STARTED = 'RESOLVE_THREAD_SALES_STARTED'

export const RESOLVE_THREAD_SERVICE_STARTED = 'RESOLVE_THREAD_SERVICE_STARTED'

export const RESOLVE_THREAD_REVIEW_STARTED = 'RESOLVE_THREAD_REVIEW_STARTED'

export const RESOLVE_THREAD_SERVICE_SUCCESS = 'RESOLVE_THREAD_SERVICE_SUCCESS'

export const RESOLVE_THREAD_SALES_SUCCESS = 'RESOLVE_THREAD_SALES_SUCCESS'

export const RESOLVE_THREAD_DIRECT_STARTED = 'RESOLVE_THREAD_DIRECT_STARTED'

export const RESOLVE_THREAD_DIRECT_SUCCESS = 'RESOLVE_THREAD_DIRECT_SUCCESS'

export const GET_NEW_MESSAGE = 'GET_NEW_MESSAGE'

export const GET_ARRIVALS_STARTED = 'GET_ARRIVALS_STARTED'

export const GET_ARRIVALS_SUCCESS = 'GET_ARRIVALS_SUCCESS'

export const GET_ARRIVALS_FAILED = 'GET_ARRIVALS_FAILED'

export const POST_GUEST_FOR_CHAT_STARTED = 'POST_GUEST_FOR_CHAT_STARTED'

export const POST_GUEST_FOR_CHAT_SUCCESS = 'POST_GUEST_FOR_CHAT_SUCCESS'

export const POST_GUEST_FOR_CHAT_INITIATED = 'POST_GUEST_FOR_CHAT_INITIATED'

export const POST_GUEST_FOR_CHAT_FAILED = 'POST_GUEST_FOR_CHAT_FAILED'

export const WS_CONNECTED = 'WS_CONNECTED'

export const WS_DISCONNECTED = 'WS_DISCONNECTED'

export const GOT_SOCKET_MESSAGE = 'GOT_SOCKET_MESSAGE'

export const GET_DIRECT_CHATS_STARTED = 'GET_DIRECT_CHATS_STARTED'

export const GET_DIRECT_CHATS_SUCCESS = 'GET_DIRECT_CHATS_SUCCESS'

export const GET_DIRECT_CHATS_FAILED = 'GET_DIRECT_CHATS_FAILED'

export const GET_DIRECT_THREAD_STARTED = 'GET_DIRECT_THREAD_STARTED'

export const GET_DIRECT_THREAD_FAILED = 'GET_DIRECT_THREAD_FAILED'

export const GET_DIRECT_THREAD_SUCCESS = 'GET_DIRECT_THREAD_SUCCESS'

export const UPDATE_DIRECT_CHATS_STARTED = 'UPDATE_DIRECT_CHATS_STARTED'

export const GET_DIRECT_MESSAGE_FROM_PUSH = 'GET_DIRECT_MESSAGE_FROM_PUSH'

export const SEND_DIRECT_MESSAGE_STARTED = 'SEND_DIRECT_MESSAGE_STARTED'

export const SEND_DIRECT_MESSAGE_FAILED = 'SEND_DIRECT_MESSAGE_FAILED'

export const SEND_DIRECT_MESSAGE_SUCCESS = 'SEND_DIRECT_MESSAGE_SUCCESS'

export const GET_REVIEW_THREAD_STARTED = 'GET_REVIEW_THREAD_STARTED'

export const GET_REVIEW_THREAD_FAILED = 'GET_REVIEW_THREAD_FAILED'

export const GET_REVIEW_THREAD_SUCCESS = 'GET_REVIEW_THREAD_SUCCESS'

export const GET_REVIEW_CHATS_STARTED = 'GET_REVIEW_CHATS_STARTED'

export const GET_REVIEW_CHATS_SUCCESS = 'GET_REVIEW_CHATS_SUCCESS'

export const GET_REVIEW_CHATS_FAILED = 'GET_REVIEW_CHATS_FAILED'

export const UPDATE_REVIEW_CHATS_STARTED = 'UPDATE_REVIEW_CHATS_STARTED'

export const RESOLVE_THREAD_REVIEW_SUCCESS = 'RESOLVE_THREAD_REVIEW_SUCCESS'

export const GET_REVIEW_MESSAGE_FROM_PUSH = 'GET_REVIEW_MESSAGE_FROM_PUSH'

export const SEND_REVIEW_MESSAGE_STARTED = 'SEND_REVIEW_MESSAGE_STARTED'

export const SEND_REVIEW_MESSAGE_FAILED = 'SEND_REVIEW_MESSAGE_FAILED'

export const SEND_REVIEW_MESSAGE_SUCCESS = 'SEND_REVIEW_MESSAGE_SUCCESS'

export const UPDATE_SALES_CHATS_STARTED = 'UPDATE_SALES_CHATS_STARTED'

export const UPDATE_SERVICE_CHATS_STARTED = 'UPDATE_SERVICE_CHATS_STARTED'

export const GET_SALES_CHATS_STARTED = 'GET_SALES_CHATS_STARTED'

export const GET_SALES_CHATS_SUCCESS = 'GET_SALES_CHATS_SUCCESS'

export const GET_SERVICE_CHATS_FAILED = 'GET_SERVICE_CHATS_FAILED'

export const GET_RESOLVED_SALES_CHATS_STARTED = 'GET_RESOLVED_SALES_CHATS_STARTED'

export const GET_RESOLVED_SALES_CHATS_SUCCESS = 'GET_RESOLVED_SALES_CHATS_SUCCESS'

export const GET_INTENT_TYPES_SUCCESS = 'GET_INTENT_TYPES_SUCCESS'

export const GET_RESOLVED_SALES_CHATS_FAILED = 'GET_RESOLVED_SALES_CHATS_FAILED'

export const GET_SERVICE_CHATS_STARTED = 'GET_SERVICE_CHATS_STARTED'

export const GET_SERVICE_CHATS_SUCCESS = 'GET_SERVICE_CHATS_SUCCESS'

export const GET_SALES_CHATS_FAILED = 'GET_SALES_CHATS_FAILED'

export const SEND_PUSH_SUBSCRIPTION_STARTED = 'SEND_PUSH_SUBSCRIPTION_STARTED'

export const SEND_PUSH_SUBSCRIPTION_SUCCESS = 'SEND_PUSH_SUBSCRIPTION_SUCCESS'

export const SEND_PUSH_SUBSCRIPTION_FAILED = 'SEND_PUSH_SUBSCRIPTION_FAILED'

export const POST_TYPING_STARTED = 'POST_TYPING_STARTED'

export const POST_TYPING_FAILED = 'POST_TYPING_FAILED'

export const POST_TYPING_SUCCESS = 'POST_TYPING_SUCCESS'

export const UPDATE_TYPING_USERS = 'UPDATE_TYPING_USERS'

export const UPDATE_SINGLE_TYPING_USER = 'UPDATE_SINGLE_TYPING_USER'

export const UPDATE_SERVICE_TYPING_USERS = 'UPDATE_SERVICE_TYPING_USERS'

export const UPDATE_SALES_TYPING_USERS = 'UPDATE_SALES_TYPING_USERS'

export const UPDATE_REVIEW_TYPING_USERS = 'UPDATE_REVIEW_TYPING_USERS'

export const UPDATE_DIRECT_TYPING_USERS = 'UPDATE_DIRECT_TYPING_USERS'

export const UPDATE_SINGLE_SALES_TYPING_USER = 'UPDATE_SINGLE_SALES_TYPING_USER'

export const UPDATE_SINGLE_SERVICE_TYPING_USER = 'UPDATE_SINGLE_SERVICE_TYPING_USER'

export const UPDATE_SINGLE_REVIEW_TYPING_USER = 'UPDATE_SINGLE_REVIEW_TYPING_USER'

export const UPDATE_SINGLE_DIRECT_TYPING_USER = 'UPDATE_SINGLE_DIRECT_TYPING_USER'

export const UPDATE_SERVICE_STARTED = 'UPDATE_SERVICE_STARTED'

export const UPDATE_SERVICE_FAILED = 'UPDATE_SERVICE_FAILED'

export const UPDATE_SERVICE_SUCCESS = 'UPDATE_SERVICE_SUCCESS'

export const DELETE_EXCLUSION_STARTED = 'DELETE_EXCLUSION_STARTED'

export const DELETE_EXCLUSION_FAILED = 'DELETE_EXCLUSION_FAILED'

export const DELETE_EXCLUSION_SUCCESS = 'DELETE_EXCLUSION_SUCCESS'

export const UPDATE_CURRENT_HOTEL = 'UPDATE_CURRENT_HOTEL'

export const UPDATE_HOTEL_DATA = 'UPDATE_HOTEL_DATA'

export const GET_INSIGHTS_STARTED = 'GET_INSIGHTS_STARTED'

export const GET_INSIGHTS_FAILED = 'GET_INSIGHTS_FAILED'

export const GET_ONE_TIME_GUEST_DATA_SUCCESS = 'GET_ONE_TIME_GUEST_DATA_SUCCESS'

export const GET_REPEAT_GUEST_DATA_SUCCESS = 'GET_REPEAT_GUEST_DATA_SUCCESS'

export const GET_INSIGHTS_SUCCESS = 'GET_INSIGHTS_SUCCESS'

export const UPDATE_CURRENT_BALANCE = 'UPDATE_CURRENT_BALANCE'

export const UPDATE_GROUP_VIEW_PREFERENCE = 'UPDATE_GROUP_VIEW_PREFERENCE'

export const PUSH_NEW_NOTIFICATION = 'PUSH_NEW_NOTIFICATION'

export const GET_NOTICATIONS_STARTED = 'GET_NOTICATIONS_STARTED'

export const GET_NOTICATIONS_SUCCESS = 'GET_NOTICATIONS_SUCCESS'

export const GET_NOTICATIONS_FAILED = 'GET_NOTICATIONS_FAILED'

export const OVERWRITE_NOTIFICATIONS = 'OVERWRITE_NOTIFICATIONS'

export const GET_NOTIFICATION_PREFERENCES_STARTED = 'GET_NOTIFICATION_PREFERENCES_STARTED'

export const UPDATE_NOTIFICATION_PREFERENCES_STARTED =
  'UPDATE_NOTIFICATION_PREFERENCES_STARTED'

export const UPDATE_NOTIFICATION_PREFERENCES_FAILED =
  'UPDATE_NOTIFICATION_PREFERENCES_FAILED'

export const UPDATE_NOTIFICATION_PREFERENCES_SUCCESS =
  'UPDATE_NOTIFICATION_PREFERENCES_SUCCESS'

export const GET_NOTIFICATION_PREFERENCES_SUCCESS = 'GET_NOTIFICATION_PREFERENCES_SUCCESS'

export const GET_NOTIFICATION_PREFERENCES_FAILED = 'GET_NOTIFICATION_PREFERENCES_FAILED'

export const UPDATE_SUBSIDIARY_ID_FOR_SINGLE_INVOICE =
  'UPDATE_SUBSIDIARY_ID_FOR_SINGLE_INVOICE'

export const CHANGE_CHAT_OWNERSHIP_STARTED = 'CHANGE_CHAT_OWNERSHIP_STARTED'

export const CHANGE_CHAT_OWNERSHIP_SUCCESS = 'CHANGE_CHAT_OWNERSHIP_SUCCESS'

export const CHANGE_CHAT_OWNERSHIP_FAILED = 'CHANGE_CHAT_OWNERSHIP_FAILED'

export const CHANGE_THREAD_OWNER = 'CHANGE_THREAD_OWNER'

export const OPTING_OUT_GUEST_FROM_CHAT_STARTED = 'OPTING_OUT_GUEST_FROM_CHAT_STARTED'

export const OPTING_OUT_GUEST_FROM_CHAT_FAILED = 'OPTING_OUT_GUEST_FROM_CHAT_FAILED'

export const OPTING_OUT_GUEST_FROM_CHAT_SUCCESS = 'OPTING_OUT_GUEST_FROM_CHAT_SUCCESS'

export const OPTING_IN_GUEST_TO_CHAT_STARTED = 'OPTING_IN_GUEST_TO_CHAT_STARTED'

export const OPTING_IN_GUEST_TO_CHAT_FAILED = 'OPTING_IN_GUEST_TO_CHAT_FAILED'

export const OPTING_IN_GUEST_TO_CHAT_SUCCESS = 'OPTING_IN_GUEST_TO_CHAT_SUCCESS'

export const GET_INVOICES_LIST_STARTED = 'GET_INVOICES_LIST_STARTED'

export const GET_INVOICES_LIST_SUCCESS = 'GET_INVOICES_LIST_SUCCESS'

export const GET_INVOICES_LIST_FAILED = 'GET_INVOICES_LIST_FAILED'

export const GET_PAYMENT_LIST_STARTED = 'GET_PAYMENT_LIST_STARTED'

export const GET_PAYMENT_LIST_FAILED = 'GET_PAYMENT_LIST_FAILED'

export const GET_PAYMENT_LIST_SUCCESS = 'GET_PAYMENT_LIST_SUCCESS'

export const SEND_INVOICE_STARTED = 'SEND_INVOICE_STARTED'

export const SEND_INVOICE_SUCCESS = 'SEND_INVOICE_SUCCESS'

export const SEND_INVOICE_FAILED = 'SEND_INVOICE_FAILED'

export const GET_BILLING_CONTACTS_STARTED = 'GET_BILLING_CONTACTS_STARTED'

export const GET_BILLING_CONTACTS_FAILED = 'GET_BILLING_CONTACTS_FAILED'

export const GET_BILLING_CONTACTS_SUCCESS = 'GET_BILLING_CONTACTS_SUCCESS'

export const RETRY_PAYMENT_STARTED = 'RETRY_PAYMENT_STARTED'

export const RETRY_PAYMENT_SUCCESS = 'RETRY_PAYMENT_SUCCESS'

export const RETRY_PAYMENT_FAILED = 'RETRY_PAYMENT_FAILED'

export const UPDATE_PAYMENT_STARTED = 'UPDATE_PAYMENT_STARTED'

export const UPDATE_PAYMENT_SUCCESS = 'UPDATE_PAYMENT_SUCCESS'

export const UPDATE_PAYMENT_FAILED = 'UPDATE_PAYMENT_FAILED'

export const GET_HEALTH_CHECK_AUTOINVITE_DATA_STARTED =
  'GET_HEALTH_CHECK_AUTOINVITE_DATA_STARTED'

export const GET_HEALTH_CHECK_AUTOINVITE_DATA_FAILED =
  'GET_HEALTH_CHECK_AUTOINVITE_DATA_FAILED'

export const GET_HEALTH_CHECK_AUTOINVITE_DATA_SUCCESS =
  'GET_HEALTH_CHECK_AUTOINVITE_DATA_SUCCESS'

export const GET_HEALTH_CHECK_SYNC_DATA_SUCCESS = 'GET_HEALTH_CHECK_SYNC_DATA_SUCCESS'

export const GET_HEALTH_CHECK_SYNC_DATA_FAILED = 'GET_HEALTH_CHECK_SYNC_DATA_FAILED'

export const GET_HEALTH_CHECK_SYNC_DATA_STARTED = 'GET_HEALTH_CHECK_SYNC_DATA_STARTED'

export const GET_HEALTH_CHECK_SYNC_BILLING_SUCCESS =
  'GET_HEALTH_CHECK_SYNC_BILLING_SUCCESS'

export const GET_HEALTH_CHECK_SYNC_BILLING_FAILED = 'GET_HEALTH_CHECK_SYNC_BILLING_FAILED'

export const GET_HEALTH_CHECK_SYNC_BILLING_STARTED =
  'GET_HEALTH_CHECK_SYNC_BILLING_STARTED'

export const GET_HEALTH_CHECK_INVOICES_STARTED = 'GET_HEALTH_CHECK_INVOICES_STARTED'

export const GET_HEALTH_CHECK_INVOICES_SUCCESS = 'GET_HEALTH_CHECK_INVOICES_SUCCESS'

export const GET_HEALTH_CHECK_INVOICES_FAILED = 'GET_HEALTH_CHECK_INVOICES_FAILED'

export const UPDATE_GROUP_BILLING_PERMISSION = 'UPDATE_GROUP_BILLING_PERMISSION'

export const INTERNAL_ADMIN_LOGGED_IN = 'INTERNAL_ADMIN_LOGGED_IN'

export const AUTO_SELECT_HOTEL_STARTED = 'AUTO_SELECT_HOTEL_STARTED'

export const AUTO_SELECTED_HOTEL = 'AUTO_SELECTED_HOTEL'

export const AUTO_SELECT_HOTEL_FAILED = 'AUTO_SELECT_HOTEL_FAILED'

export const BUMP_PENDING_SALES_THREAD_COUNT = 'BUMP_PENDING_SALES_THREAD_COUNT'
export const BUMP_PENDING_SERVICE_THREAD_COUNT = 'BUMP_PENDING_SERVICE_THREAD_COUNT'
export const BUMP_PENDING_REVIEW_THREAD_COUNT = 'BUMP_PENDING_REVIEW_THREAD_COUNT'
export const BUMP_PENDING_DIRECT_THREAD_COUNT = 'BUMP_PENDING_DIRECT_THREAD_COUNT'

export const UPDATE_PENDING_THREAD_COUNT = 'UPDATE_PENDING_THREAD_COUNT'

export const BUMP_PENDING_BOOKING_COUNT = 'BUMP_PENDING_BOOKING_COUNT'

export const BUMP_PENDING_GDS_CHAT_COUNT = 'BUMP_PENDING_GDS_CHAT_COUNT'

export const UPDATE_INVITE_BACK_IS_DISABLED = 'UPDATE_INVITE_BACK_IS_DISABLED'

export const UPDATE_ACTIVE_SERVICES = 'UPDATE_ACTIVE_SERVICES'
